import cx from 'classnames';
import { Button } from 'components/Form/Button';
import { withHandlers } from 'recompose';
import PriceBox from '../PriceBox';
import styles from './styles.css';

export default withHandlers({
  onClick:
    ({ isUnavailable, onSelect, type }) =>
    (e) => {
      e.preventDefault();
      return !isUnavailable && onSelect(type);
    },
})(
  ({
    name,
    price,
    description,
    onClick,
    buttonText,
    isCurrent,
    isPopular,
    isTrial,
    isUnavailable,
    className,
  }: any) => {
    const onClickHandler = (e) => {
      if (!isCurrent) onClick(e);
    };

    return (
      <div
        className={cx(styles.wrap, className, {
          [styles.wrap]: !isCurrent,
          [styles.current]: isCurrent,
          [styles.popular]: isPopular,
          [styles.unavailable]: isUnavailable,
        })}
        onClick={onClickHandler}
      >
        {isPopular && (
          <div className={styles['popular-label']}>Most popular plan</div>
        )}
        {isTrial && <div className={styles['trial-label']}>Free trial</div>}
        <div className={styles['price-box']}>
          <PriceBox name={name} price={price} size="normal" />
        </div>
        <p className={styles.description}>{description}</p>
        <div className={styles.button}>
          <Button disabled={isUnavailable || isCurrent}>{buttonText}</Button>
        </div>
      </div>
    );
  }
);
